export default {
    key: 'schynige-platte',
    common: {
        productName: 'core.productNames.schynige-platte',
        splashMessage: 'offerFlow.splashMessage.schynige-platte',
        headingAside: 'offerFlow.headingAside.schynige-platte',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.schynige-platte',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
